angular.module('clients')
    .component('clientCategoryPickerMultiple', {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            required: "=",
        },
        templateUrl: "app/clients/client-category-picker/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function ($scope, $element, $attrs, Client) {
            let ctrl = this

            ctrl.$onInit = () => {
                Client.categories().$promise.then(items => ctrl.items = items)
            }

            ctrl.$onChanges = () => { //changes from parent controller
                ctrl.selected = ctrl.ngModel
                ctrl.ngChange()
            }
            ctrl.ngChange = () => ctrl.ngModel = ctrl.selected
        },
    })
